import attachmentReducer from "./reducers/attachmentReducer";

export default attachmentReducer;
